export default {
    chooseManager: 'Choose Manager',
    manager: 'Manager',
    designer: 'Designer',
}
